import React, { useEffect, useRef, useState } from 'react';
import { GetAllRmList } from '../../../constants/api';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { ClickAwayListener } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { getSourceList } from '../../../../common/constants/api';
const Product = ({
  masterFilter,
  updateFilters,
  doReset,
  updateSelectionFieldsInHTMLFormatForDeSelect,
  ...props
}) => {
  const [sourceList, setSourceList] = useState();
  const [selectionStatus, setSelectionStatus] = useState(
    masterFilter?.source || {}
  );
  const [openOptions, setOpenOptions] = useState(false);
  const [inputChange, setInputChange] = useState('');

  const autocompleteRef = useRef('');
  useEffect(() => {
    getSourceList()
      .then(res => {
        setSourceList(res);
      })
      .catch(error => {});
  }, []);
  useEffect(() => {
    if (doReset) {
      setSelectionStatus({});
    }
  }, [doReset]);

  useEffect(() => {
    let a = {};
  }, []);
  useEffect(() => {
    updateFilters({
      key: 'source',
      filters: selectionStatus
    });
    let onlyStatusTrue = {};
    Object.keys(selectionStatus || {})?.forEach(each => {
      if (selectionStatus[each]?.status && selectionStatus[each]?.fullName)
        onlyStatusTrue[each] = selectionStatus[each];
    });

    updateSelectionFieldsInHTMLFormatForDeSelect({
      key: 'source',
      object: onlyStatusTrue,
      handleCancel: handleCancel,
      displayName: 'fullName'
    });
  }, [selectionStatus]);

  const handleCancel = e => {
    setSelectionStatus(e);
  };

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const autoCompleteChange = (e, data, type) => {
    if (!data || typeof data != 'object') return setSelectionStatus('');

    if (props?.dependencyData?.multiSelect) {
      let newData = {};
      data?.forEach(each => {
        newData[each?.id] = {
          fullName: each?.displayName,
          status: !selectionStatus[each?.id]?.status || true,
          id: each?.id
        };
      });
      return setSelectionStatus(newData);
    } else {
      return setSelectionStatus({
        [data?.id]: {
          fullName: data?.displayName,
          status: !selectionStatus[data?.id]?.status || false
        }
      });
    }
  };

  const useStyles = makeStyles(theme => ({
    root: {
      '& > * + *': {
        marginTop: theme.spacing(2)
      }
    },
    popper: {
      overflow: 'hidden'
    }
  }));

  const classes = useStyles();

  const handleClickEvent = e => {
    if (!props?.dependencyData?.multiSelect) return;
    if (
      typeof autocompleteRef?.current?.contains != 'function' ||
      typeof e?.target?.classList != 'object'
    )
      return;
    if (
      !e?.target?.classList?.contains('MuiAutocomplete-option') &&
      !autocompleteRef?.current?.contains(e?.target)
    ) {
      setOpenOptions(false);
    }
  };
  useEffect(() => {
    window?.addEventListener('click', handleClickEvent);

    return () => window?.removeEventListener('click', handleClickEvent);
  }, []);
  return (
    <div className="w-full">
      <p className="font-roboto font-medium text-base">Source Filter</p>
      <div className={`mt-4`}>
        <Autocomplete
          {...(props?.dependencyData?.multiSelect
            ? {
                onFocus: async e => {
                  await setOpenOptions(true);
                },
                open: openOptions,
                ref: autocompleteRef
              }
            : {})}
          options={sourceList}
          disableCloseOnSelect
          multiple={props?.dependencyData?.multiSelect}
          getOptionLabel={option => option.displayName || ''}
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.displayName}
            </React.Fragment>
          )}
          renderInput={params => (
            <TextField
              {...params}
              variant="outlined"
              label="Source"
              placeholder="Select Source"
            />
          )}
          classes={{ popper: classes.popper }}
          onChange={autoCompleteChange}
          value={
            props?.dependencyData?.multiSelect
              ? sourceList?.filter(each =>
                  Object.keys(selectionStatus || {})?.includes(`${each?.id}`)
                )
              : sourceList?.filter(
                  each =>
                    `${each?.id}` == Object.keys(selectionStatus || {})?.[0]
                )?.[0]
          }
        />
      </div>
    </div>
  );
};

export default Product;
